import axios from "axios";

async function sendEmail(data) {
  try {
    const res = await axios.post(`${process.env.REACT_APP_URI}/contact`, data, {
      headers: { "Content-Type": "application/json" },
    });

    return res;
  } catch (e) {
    console.error(e);
    return e;
  }
}

export { sendEmail };
